<template>
  <section id="osteopathie">
    <h2 class="text-uppercase text-center">
      Osteopathie
    </h2>
    <p>Die Osteopathie als manuelle Medizin wurde Ende des 19. Jahrhunderts vom amerikanischen Arzt Andrew Taylor Still begründet.</p>
    <p>
      Er sah den Körper als untrennbare Einheit, mit dem grundsätzlichen Bestreben zur Selbstheilung an. Die Basis dafür sollte eine gute Beweglichkeit aller Körperstrukturen, wie z.B. der Muskeln, Faszien, Bauchorgane oder der Blutgefässe, sein.
    </p>
    <p>Ziel einer osteopathischen Behandlung ist es daher immer, mögliche Bewegungseinschränkungen aufzuspüren, zu beseitigen und so den Selbstheilungskräften wieder mehr Raum zu geben. Um es mit den Worten von Dr. A.T. Still zu sagen:</p>
    <blockquote class="blockquote">
      <p>
        „Find it, fix it, leave it“.
      </p>
    </blockquote>
    <p>
      Die Osteopathie hat sich seitdem kontinuierlich weiterentwickelt. Sie findet Anwendung bei verschiedensten Beschwerdebildern z.B. am Bewegungsapparat, bei Verdauungsstörungen, oder auch bei Kopfschmerzen. Hier kann die Ursache auch an einem völlig anderen Ort liegen als die auftretenden Beschwerden.
    </p>
  </section>
</template>

<script>
export default {
    name: "ContentOsteopathie",
    mounted: function() {
      if(this.$route.path && this.$route.path == '/osteopathie') {
        const element = document.getElementById(this.$route.path.substring(1));
        if(element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }
}
</script>
